export enum UserType {
    Member = "Member",
    Guest = "Guest"
}